// SwitchBox.tsx
import React from "react";
import "../styles/components/switchBoxComponent.css"
type SwitchBoxProps = {
  options: string[];
  active: string;
  setActive: (value: string) => void;
};

const SwitchBox: React.FC<SwitchBoxProps> = ({ options, active, setActive }) => {
  return (
    <div className="switch-box-general-wrap grey-bg">
      <div className="switch-box-general-wrap_contents">
        {options.map((option) => (
          <p
            key={option}
            className={`switch-box-option ${active === option ? "active white-black-bg black-white-color" : ""}`}
            onClick={() => setActive(option)}
          >
            {option}
          </p>
        ))}
      </div>
    </div>
  );
};

export default SwitchBox;
